import React from "react";
import Grid from "@mui/material/Grid2";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { ui } from "../../../../../../../../../interfaces/interfaces";
import { cacheUtils } from "../../../../../../../../..";
import { CacheTypes } from "@utils/cache/interfaces";
import { useAppSelector } from "@store/hooks";

type Props = {}

const RejectDropDown: React.FC<Props> = () => {
    const serviceAgreementDeclinedReason1 = useAppSelector(({ ui }) => ui.CarePlanDeclinedReason)
    const serviceAgreementOffered = useAppSelector(({ ui }) => ui.CarePlanOffered)

    if (serviceAgreementOffered) {
        return (
            (<Grid
                size={{
                    xs: 12,
                    sm: 6
                }}>
                <Autocomplete
                    disablePortal
                    size="small"
                    id="combo-box-demo"
                    options={cacheUtils.getCache<CacheTypes.ServiceAgreementDeclinedReason>("ServiceAgreementDeclinedReason")}
                    getOptionLabel={option => option?.serviceAgreementDeclinedReason1 ? option?.serviceAgreementDeclinedReason1 : ""}
                    value={serviceAgreementDeclinedReason1}
                    onChange={(e, v) => ui.CarePlanDeclinedReason = v}
                    sx={{ width: 250 }}
                    renderInput={(params) => <TextField {...params} label="Rejection reason" sx={{ '& > div > input': { padding: "7.5px 4px 7.5px 6px !important" } }} />}
                />
            </Grid>)
        );
    }

    return null;
}

export default RejectDropDown